import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

// A persistent shortcut back to the exact alert card the user just came
// from, rendered on top of ANY page reached by opening an alert (title page
// etc.) — mirrors BackToNotifications for the Availability Alerts page.
export function BackToAlerts() {
  const location = useLocation();
  const navigate = useNavigate();
  const alertId = location.state?.fromAlert;
  if (!alertId || location.pathname === "/app/alerts") return null;
  return (
    <button data-testid="back-to-alerts"
      onClick={() => navigate("/app/alerts", { state: { scrollToId: alertId } })}
      className="fixed bottom-24 left-4 z-40 flex items-center gap-2 rounded-full border border-gold/40 bg-[#0D1117]/95 px-4 py-2.5 text-[13px] font-bold text-gold shadow-[0_10px_30px_-10px_rgba(0,0,0,0.65)] backdrop-blur-md transition-colors hover:bg-gold hover:text-gold-ink lg:bottom-6 lg:left-[268px]">
      <ArrowLeft size={15} weight="bold" />
      Back to Alerts
    </button>
  );
}
